import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgStyle, NgIf } from '@angular/common';

@Component({
    selector: 'app-texto-link',
    templateUrl: './texto-link.component.html',
    styleUrls: ['./texto-link.component.css'],
    standalone: true,
    imports: [NgStyle, NgIf]
})
export class TextoLinkComponent {

  @Input() titulo = '';
  @Input() icone = null;
  @Input() disabled = false;
  @Output() click = new EventEmitter<void>();

  handleClick(event: MouseEvent) {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.click.emit();
  }

}
